<template>
  <div>
    <div v-if="isShareable && listItem">
      <v-list-item v-if="isCopyCommandEnabled === true" @click="copyToClipboard()">
        <v-list-item-icon>
          <v-icon>mdi-content-copy</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="wrap-normal">{{ $t('label.copyLinkToClipboard') }}</v-list-item-subtitle>
      </v-list-item>
      <v-list-item v-if="isShareable && isShareApiEnabled === true && !hideShareButton" @click="share()">
        <v-list-item-icon>
          <v-icon>mdi-share-variant</v-icon>
        </v-list-item-icon>
        <v-list-item-subtitle class="wrap-normal">{{ $t('label.share') }}</v-list-item-subtitle>
      </v-list-item>
    </div>
  </div>
</template>

<script>
import common from '@/mixins/common';
const MIME_TYPES = { jpg: 'image/jpeg', png: 'image/png', pdf: 'application/pdf', mp4: 'video/mp4', avi: 'video/x-msvideo' };

const FILES = ['image', 'video', 'audio', 'text'];

export default {
  name: 'ShareButton',
  mixins: [common],
  props: {
    listItem: {
      type: Boolean,
      default: false,
    },
    file: Object,

    moduleBackendId: String,
    color: String,
    hideShareButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialShare: false,
      isCopyCommandEnabled: false,
      isShareApiEnabled: false,
    };
  },

  mounted() {
    this.isCopyCommandSupported();
    this.checkIfShareApiIsEnabled();
    console.debug('fileType', this.getFileType());
  },
  computed: {
    isShareable() {
      return true;
    },
  },
  methods: {
    async copyToClipboard() {
      try {
        // this should check the support for the copy command. However it does not seem to run on Safari
        // TODO: Fix feature detect
        await navigator.clipboard.writeText(`${window.location.href}`);

        console.debug('clipboard successfully set writeResult');
      } catch (e) {
        console.warn('copyToClipboard failed', e);
      }
    },
    checkIfShareApiIsEnabled() {
      console.debug('isShareApiEnabled', navigator.share);
      this.isShareApiEnabled = navigator.share !== undefined;
    },
    isCopyCommandSupported() {
      navigator.permissions
        .query({ name: 'clipboard-write' })
        .then((result) => {
          console.debug('isCopyCommandSupported', result);
          this.isCopyCommandEnabled = result.state == 'granted' || result.state == 'prompt';
        })
        .catch((err) => {
          console.warn('isCopyCommandSupported error', err);
        });
    },
    getFileType() {
      if (this.file && this.file.filename) {
        let dot = this.file.filename.lastIndexOf('.');
        if (dot > 0) {
          return this.file.filename.substring(dot + 1);
        }
      }
      return null;
    },
    checkBasicFileShare() {
      // XXX: There is no straightforward API to do this.
      // For now, assume that text/plain is supported everywhere.
      const txt = new Blob(['Hello, world!'], { type: 'text/plain' });
      // XXX: Blob support? https://github.com/w3c/web-share/issues/181
      const file = new File([txt], 'test.txt');
      return navigator.canShare({ files: [file] });
    },

    testWebShare(files) {
      if (files && files.length > 0) {
        if (!navigator.canShare) {
          console.debug('Warning: canShare is not supported. File sharing may not be supported at all.');
        } else if (!this.checkBasicFileShare()) {
          console.debug('Error: File sharing is not supported in this browser.');
          return false;
        } else if (!navigator.canShare({ files })) {
          console.debug('Error: share() does not support the given files');
          for (const file of files) {
            console.debug(`File info: name - ${file.name}, size ${file.size}, type ${file.type}`);
          }
          return false;
        }
      }
    },
    /**
     * Example file sharing: See https://w3c.github.io/web-share/demos/share-files.html
     * Example shaaring: https://mdn.github.io/dom-examples/web-share/
     */
    async share() {
      let type = MIME_TYPES[this.getFileType()];
      let { filename, checksum } = this.file;
      let filenameAttribute = 'filename';
      let url = this.constructPdfJsFileUrl(this.moduleBackendId, this.file, filenameAttribute);
      console.debug('share for mime type', type);
      fetch(url)
        .then((response) => response.blob())
        .then(
          (blob) => {
            let file = new File([blob], filename, { type });
            let filesArray = [file];

            //  if (navigator.canShare && navigator.canShare({ files: filesArray })) {
            navigator
              .share({
                text: 'some_text',
                files: filesArray,
                title: this.file.title,
                url,
              })
              .then(() => {
                console.debug('Share was successful.');
                alert('share success');
              })
              .catch((error) => console.warn('Sharing failed', error));
          }
          // }
        );
    },
  },
};
</script>
